// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseData } from './EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseData.gen';
import type { EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseErrors } from './EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseErrors.gen';
import type { EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseResponses } from './EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseResponses.gen';
import type { EshopCompanyCardControllerCheckCompanyCardsTicketFareValidData } from './EshopCompanyCardControllerCheckCompanyCardsTicketFareValidData.gen';
import type { EshopCompanyCardControllerCheckCompanyCardsTicketFareValidErrors } from './EshopCompanyCardControllerCheckCompanyCardsTicketFareValidErrors.gen';
import type { EshopCompanyCardControllerCheckCompanyCardsTicketFareValidResponses } from './EshopCompanyCardControllerCheckCompanyCardsTicketFareValidResponses.gen';
import type { EshopCompanyCardControllerTransferTicketFareData } from './EshopCompanyCardControllerTransferTicketFareData.gen';
import type { EshopCompanyCardControllerTransferTicketFareErrors } from './EshopCompanyCardControllerTransferTicketFareErrors.gen';
import type { EshopCompanyCardControllerTransferTicketFareResponses } from './EshopCompanyCardControllerTransferTicketFareResponses.gen';
import type { Options } from './Options.gen';

export class EshopCompanyCardController {
    /**
     * Get cards available for ticket fares purchase.
     */
    public static getCompanyCardsForTicketFarePurchase<ThrowOnError extends boolean = false>(options?: Options<EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseResponses, EshopCompanyCardControllerGetCompanyCardsForTicketFarePurchaseErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/company-cards/ticket-fares-purchase',
            ...options
        });
    }
    
    /**
     * Get cards available for ticket fares purchase.
     */
    public static checkCompanyCardsTicketFareValid<ThrowOnError extends boolean = false>(options: Options<EshopCompanyCardControllerCheckCompanyCardsTicketFareValidData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCompanyCardControllerCheckCompanyCardsTicketFareValidResponses, EshopCompanyCardControllerCheckCompanyCardsTicketFareValidErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/company-cards/check-ticket-fare-valid',
            ...options
        });
    }
    
    /**
     * Transfer a ticket fare from one company card to another.
     */
    public static transferTicketFare<ThrowOnError extends boolean = false>(options: Options<EshopCompanyCardControllerTransferTicketFareData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCompanyCardControllerTransferTicketFareResponses, EshopCompanyCardControllerTransferTicketFareErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/company-cards/{id}/ticket-fares/{ticketFareId}/transfer',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
